
import { getPostList } from '@/api/post';
import { Component, Vue } from 'vue-property-decorator';
import { IPost } from '@/types/post';
import { IBoard, IField } from '@/types/board';
import { parseDate } from '@/utils/filters';

@Component({
  name: 'faq',
  components: {
  },
})
export default class extends Vue {
  mounted() {
    this.getPostList();
  }

  private listLoading: boolean = true;

  private listQuery = {
    boardUid: '5c955248-4573-4039-a92f-6b6f2169d91d',
    searchType: 'title',
    searchValue: '',
    page: 0,
    size: 10,
  };

  private boardList: IBoard[] = [];

  private boardFieldList: IField[] = [];

  private searchFieldList: IField[] = [];

  private searchBoardUid: string = ''; // 검색 완료된 게시판 고유값

  private postList: IPost[] = [];

  private totalElements: number = 0;

  private showFlag = false;

  private showtext : {}[] = [];

  private getPostList() {
    this.listLoading = true;
    getPostList(this.listQuery).then((res) => {
      this.listLoading = false;
      const postList: any = [];
      res.data.content.forEach((post: any) => {
        postList.push({
          ...post,
          showStatus: false,
        });
      });
      this.postList = postList;
      this.totalElements = res.data.totalElements;
      this.setBoard(this.listQuery.boardUid);
    });
  }

  private setBoard(boardUid: string) {
    const boardIndex = this.boardList.findIndex((board: IBoard) => board.uid === boardUid);
    if (boardIndex > -1) {
      const targetBoard: IBoard = this.boardList[boardIndex];
      this.boardFieldList = targetBoard.fieldList.filter((bf: IField, index: number) => index === 0);
      this.listQuery.searchType = 'title';
      if (this.searchBoardUid !== this.listQuery.boardUid) {
        this.searchFieldList = targetBoard.fieldList.filter((bf: IField) => bf.searchState);
      }
    }
  }

  private toggletext(idx : any) {
    console.log(this.showtext[idx]);
    if (this.showtext[idx] !== false) {
      this.showFlag = false;
    } else {
      this.showFlag = true;
    }
    this.showtext[idx] = this.showFlag;
    console.log(this.showtext[idx]);
  }

  private handleClickPost(post: any) {
    post.showStatus = !post.showStatus;
  }

  private baseUrl = process.env.VUE_APP_TARGET;
}
